import React, { useState, useEffect, useRef, useMemo } from 'react'
import styled from 'styled-components';
import logo from '../../images/MegaPlazaBuilding.jpg';
import { delay } from '../../utils/delay';
import { addDepartment, editDepartment } from '../../redux/deptSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale } from '../../utils/currentDate';
import { useSelector } from 'react-redux';
import { mobile } from '../../responsive';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
`

const Wrapper = styled.div`
    width: 60vw;
    background-color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    -webkit-appearance: none;
    -moz-box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
     
    -webkit-box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
     
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
     
    ${mobile({
        width: '70vw',
    })};
`

const Title = styled.h1`
    text-decoration: underline;
    text-decoration-color: gray;
    text-underline-offset: 6px;
    margin: 5px;
    text-align: center;
`

const SubTitle = styled.h1`
    color: red;
    margin: 5px;
    font-size: 15px;
    
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
`

const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'center',
    })};
`

const FormColumn = styled.div`

`

const FormLabel = styled.h1`
    font-size: 20px;
    font-weight: 300;
    margin: 5px;
    padding: 10px;
    
     ${mobile({
         textAlign: 'center'
     })}
`

const FormInput = styled.input`
    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;
    border-radius: 5px;
    border: none;
   
    -webkit-appearance: none;

    -moz-box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);

    -webkit-box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
     &:hover, &:focus {
        -moz-box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
        -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
         box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
     }
    ${mobile({
        width: '60vw'
    })};
`

const Button = styled.button`
    padding: 10px 20px;
    margin: 30px 20px;
    border-radius: 10px;
    color: white;
    background: rgba(0, 200, 200, 0.9);
    cursor: pointer;
    border: none;
    font-size: 20px;
    font-weight: bold;
    -webkit-appearance: none;
    -moz-box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    &:hover{
        box-shadow: none;
    }
`

const FormMessageBox = styled.h1`
    height: 20px;
    font-size: 20px;
    margin: 0;
    visibility: ${props => props?.messageType ? 'visible' : 'hidden'};
    color: ${props => props?.messageType === 1 ? 'green' : 'red'};
`

const Department = ({deptIdToEdit}) => {

    //console.log(deptIdToEdit);
    const initialState = {
        'deptId' : '',
        'deptName' : '',
        'deptDesc' : '',
        'deptHead' : '',
        'updatedDate' : '',
        'createdDate' : ''
    };
    const [department, setDepartment] = useState(initialState);
    const [formMessage, setFormMessage] = useState({});
    const [edit, setEdit] = useState(false);
    const dispatch = useDispatch();
    const dept = useSelector(state => state.dept);
    const formRef = useRef();
    const departments = useMemo(() => [...dept?.departments], [dept?.departments]);
    

    const clearState = () => {
        setDepartment({...initialState});
        setEdit(false);
    };

    useEffect(() => {

        if(deptIdToEdit && deptIdToEdit.deptId && Number(deptIdToEdit.deptId) > 0){
            setEdit(true);
            const editDept = departments?.filter((item) => item.deptId === Number(deptIdToEdit.deptId));
            if(editDept && editDept[0]){
                setDepartment(editDept[0]);
            }
            
        }

        if(formRef.current){
            formRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ deptIdToEdit]);

    const handleFormInput = (e) => {
        const {name, value} = e.target;
        setDepartment({...department, [name]: value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Create Department Clicked');
        if (department?.deptName && department?.deptDesc) {
            console.log('No Errors');
            
            if(edit){
                await dispatch(
                    editDepartment({
                        ...department, 
                        'updatedDate': currentDateLocale(),
                    })
                );
            }
            else{
                await dispatch(
                    addDepartment({
                        ...department,
                        'deptId' : getNextAvailableId(), 
                        'createdDate': currentDateLocale(),
                    })
                );
            }
            
            await clearState();
            setFormMessage({'type' : 1, 'message' : 'Department Saved Successfully'});
            //setDepartment({});

        } 
        else{
            console.log('Has Errors');
            setFormMessage({'type' : 2, 'message' : 'Some required fields are not filled'});
        }

        await delay(5000);

        setFormMessage({});

    }

    const getNextAvailableId = () => {
        return dept && dept.departments && dept.departments.length > 0 
            ? dept.departments[dept.departments.length - 1].deptId + 1 : 1;
    };

    return (
        <Container ref={formRef}>
            <Wrapper>
                <Title>
                    {edit ? 'Edit Department' : 'Create New Department'}
                </Title>
                <SubTitle>
                    * == required
                </SubTitle>
                <FormMessageBox messageType={formMessage?.type}>
                    {formMessage?.message}
                </FormMessageBox>
                <Form>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Department Name*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='deptName'
                                        placeholder= 'Enter Department Name'
                                        value = {department.deptName}
                                        onChange = {(e) => handleFormInput(e)} 

                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Department Description*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='deptDesc'
                                        placeholder='Enter Department Description'
                                        value={department.deptDesc}
                                        onChange={(e) => handleFormInput(e)}
                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Department Head
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='deptHead'
                                        placeholder='Enter Department Head'
                                        value={department.deptHead}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                </Form>
                <Button onClick={(e) => handleSubmit(e)}>
                    {edit ? 'Edit Department' : 'Create Department'}
                </Button>
            </Wrapper>
        </Container>
    )
}

export default Department
